import * as React from "react";
import Box from "@mui/material/Box";
import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Divider from "@mui/material/Divider";
import { Link } from "react-router-dom";


import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProjectsCard from "./ProjectsCard";
const theme = createTheme();

theme.typography.h3 = {
  fontSize: "28px",
  "@media (min-width:600px)": {
    fontSize: "32px",
  },

};

const HomePageProjects = () => {
    const [homePageProjectsList, setHomePageProjectsList] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    React.useEffect(() => {
      fetch("./allprojects.json")
        .then((response) => response.json())
        .then((data) => {
          setHomePageProjectsList(data);
          setIsLoading(false);
        });
    }, []);
  return (
    <Box id="projects" >
      <ThemeProvider theme={theme}>
      <Typography
        gutterBottom
        variant="h3"
        component="div"
        sx={{ textAlign: "center", pt:7, pb:2 }}
      >
        PROJECTS
        <Divider variant="middle" />

      </Typography>
      <Box sx={{ flexGrow: 1 }}>
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
        >
          {homePageProjectsList.slice(0, 3).map((homePageProject, index) => (
            <ProjectsCard isLoading={isLoading} projects={homePageProject} key={homePageProject?.id}></ProjectsCard>
          ))}
        </Grid>
      </Box>

      <Box sx={{ textAlign: "center", fontWeight: "bold", mt: 4 }}>
        <Link to="/allprojects">
          {" "}
          <Button className="button-beguni" variant="contained">
            <VisibilityIcon sx={{ m: 1 }} />
            View All Projects
          </Button>
        </Link>
      </Box>
      </ThemeProvider>

    </Box>
  );
};

export default HomePageProjects;
